import { GridRowId } from '@mui/x-data-grid-pro'
import { Country } from 'components/common/LocaleContext'
import { ImportAttendeeRowService } from 'domain/application/services/import/ImportAttendeeRowService'
import { CsvImportAttendee } from 'domain/models/Import/ImportAttendee'
import { ImportAttendeeRow } from 'domain/models/Import/ImportAttendeeRow'
import { EditionId } from 'domain/models/ValueObject/EntityIds'
import { ImportAttendeeRepository } from 'domain/repositories/ImportAttendeeRepository'

export class LiveImportAttendeeRowService implements ImportAttendeeRowService {
  constructor(
    private readonly importAttendeeRepository: ImportAttendeeRepository
  ) {}
  async create(editionId: EditionId): Promise<ImportAttendeeRow[]> {
    return this.importAttendeeRepository.create(editionId)
  }

  async addRow(row: ImportAttendeeRow, editionId: EditionId): Promise<void> {
    await this.importAttendeeRepository.addRow(row, editionId)
  }

  async saveRow(row: ImportAttendeeRow, editionId: EditionId): Promise<void> {
    await this.importAttendeeRepository.saveRow(row, editionId)
  }
  async deleteRows(
    selectedRowIds: GridRowId[],
    editionId: EditionId
  ): Promise<void> {
    await this.importAttendeeRepository.deleteRows(selectedRowIds, editionId)
  }
  async importAttendees(
    rowsToImport: CsvImportAttendee[],
    editionId: EditionId,
    countries: Country[]
  ): Promise<ImportAttendeeRow[]> {
    return this.importAttendeeRepository.importAttendees(
      rowsToImport,
      editionId,
      countries
    )
  }
}
